import { FaFacebookF, FaInstagram, FaTiktok, FaYoutube, FaWhatsapp } from 'react-icons/fa';

import LogoGooglePlay from '../../../components/atoms/Icons/LogoGooglePlay';
import LogoAppStore from '../../../components/atoms/Icons/LogoAppStore';
import Xlogo from '../../../components/atoms/Icons/Xlogo';

const ENABLE_USED_CAR_NEXTJS = process.env.NEXT_PUBLIC_ENABLE_USED_CAR_NEXTJS === 'true';

const menu = (isMobile) => {
  return [
    {
      className: 'text-[#FFFEFE] hidden text-xs md:text-sm',
      item: [
        {
          id: 'mobil-baru',
          path: '/c/mobil-baru-toyota',
          className: 'font-bold text-white transition hover:opacity-75',
          title: 'MOBIL BARU',
          show: true,
        },
        {
          id: 'yaris-cross',
          path: '/mobil-baru-toyota/p/yariscross',
          className: 'md:mt-5 transition hover:opacity-75 font-normal',
          title: 'YARIS CROSS',
          show: true,
          category: 'mobil baru',
        },
        {
          id: 'yaris-cross-hybrid',
          path: '/mobil-baru-toyota/p/yariscrosshybrid',
          className: 'transition hover:opacity-75',
          title: 'YARIS CROSS HYBRID',
          show: true,
          category: 'mobil baru',
        },
        {
          id: 'camry-hybrid',
          path: '/mobil-baru-toyota/p/camryhybrid',
          className: 'transition hover:opacity-75',
          title: 'CAMRY HYBRID',
          show: true,
          category: 'mobil baru',
        },
        {
          id: 'single-hiluxcabin',
          path: '/mobil-baru-toyota/p/hilux-4x2',
          className: 'transition hover:opacity-75 font-normal',
          title: 'HILUX SINGLE CABIN',
          show: true,
          category: 'mobil baru',
        },
        {
          id: 'hilux-double-cabin',
          path: '/mobil-baru-toyota/p/hilux-4x4',
          className: 'transition hover:opacity-75 font-normal',
          title: 'HILUX DOUBLE CABIN',
          show: true,
          category: 'mobil baru',
        },
        {
          id: 'innova-hybrid',
          path: '/mobil-baru-toyota/p/innovahybrid',
          className: 'transition hover:opacity-75',
          title: 'INNOVA HYBRID',
          show: true,
          category: 'mobil baru',
        },
        {
          id: 'agya-gr-sport',
          path: '/mobil-baru-toyota/p/agyagrsport',
          className: 'transition hover:opacity-75',
          title: 'AGYA GR SPORT',
          show: true,
          category: 'mobil baru',
        },
      ],
    },
    {
      className: 'font-base hidden md:block text-[#FFFEFE]  text-xs md:text-sm',
      item: [
        {
          id: 'mobil-bekas',
          path: ENABLE_USED_CAR_NEXTJS ? '/certified-used-car' : '/c/certified-used-car-toyota',
          className: 'font-bold text-white md:mt-5 transition hover:opacity-75',
          title: 'MOBIL BEKAS',
          show: true,
        },
        {
          id: 'purna-jual',
          path: '/services-toyota',
          className: 'font-bold text-white transition hover:opacity-75',
          title: 'PURNA JUAL',
          show: true,
        },
        {
          id: 'aksesoris',
          path: '/aksesoris',
          className: 'transition hover:opacity-75 font-normal',
          title: 'AKSESORIS',
          show: true,
          category: 'purna jual',
        },
        {
          id: 'kupon-servis',
          path: '/c/kupon-service',
          className: 'transition hover:opacity-75 font-normal',
          title: 'KUPON SERVIS',
          show: true,
          category: 'purna jual',
        },
        {
          id: 'layanan-bengkel',
          path: '/layanan-bengkel',
          className: 'transition hover:opacity-75 font-normal',
          title: 'LAYANAN BENGKEL',
          show: true,
          category: 'purna jual',
        },
        {
          id: 'layanan-home-service',
          path: '/ths-home-service',
          className: 'transition hover:opacity-75',
          title: 'LAYANAN HOME SERVICE',
          show: true,
          category: 'purna jual',
        },
        {
          id: 'bodi-dan-cat',
          path: '/body-paint-service',
          className: 'transition hover:opacity-75 font-normal',
          title: 'BODI & CAT',
          show: true,
          category: 'purna jual',
        },
        {
          id: 'trade-in',
          path: '/services-toyota/tukar-tambah',
          className: 'transition hover:opacity-75',
          title: 'TUKAR TAMBAH',
          show: true,
          category: 'purna jual',
        },
      ],
    },
    {
      className: 'font-bold  text-xs md:text-sm',
      item: [
        {
          id: 'mobil-baru-only-mobile',
          path: '/c/mobil-baru-toyota',
          className: 'text-white transition hover:opacity-75',
          title: 'MOBIL BARU',
          show: isMobile,
        },
        {
          id: 'mobil-bekas',
          path: ENABLE_USED_CAR_NEXTJS ? '/certified-used-car' : '/c/certified-used-car-toyota',
          className: 'text-white transition hover:opacity-75',
          title: 'MOBIL BEKAS',
          show: isMobile,
        },
        {
          id: 'tentang-auto2000',
          path: '/tentang-kami',
          className: 'text-white transition hover:opacity-75',
          title: 'TENTANG AUTO2000',
          show: !isMobile,
        },
        {
          id: 'promo',
          path: '/promosi',
          className: 'md:mt-5 text-white transition hover:opacity-75',
          title: 'PROMO',
          show: true,
        },
        {
          id: 'berita-tips',
          path: '/berita-dan-tips',
          className: 'text-white transition hover:opacity-75',
          title: 'BERITA & TIPS',
          show: true,
        },
        {
          id: 'pencapain',
          path: '/prestasi',
          className: 'text-white transition hover:opacity-75',
          title: 'PENCAPAIAN',
          show: !isMobile,
        },
        {
          id: 'review-produk',
          path: '/review-produk',
          className: 'text-white transition hover:opacity-75',
          title: 'REVIEW PRODUK',
          show: isMobile,
        },
        {
          id: 'akun-saya',
          path: '/myaccount/overview',
          className: 'text-white transition hover:opacity-75',
          title: 'AKUN SAYA',
          show: true,
        },
        {
          id: 'dealer-toyota',
          path: '/dealer-toyota',
          className: 'text-white transition hover:opacity-75',
          title: 'DEALER TOYOTA',
          show: !isMobile,
        },
      ],
    },
    {
      className: 'font-bold  text-xs md:text-sm',
      item: [
        {
          id: 'purna-jual',
          path: '/services-toyota',
          className: 'text-white transition hover:opacity-75',
          title: 'PURNA JUAL',
          show: isMobile,
        },
        {
          id: 'tentang-auto2000',
          path: '/tentang-kami',
          className: 'text-white md:hidden transition hover:opacity-75',
          title: 'TENTANG AUTO2000',
          show: isMobile,
        },
        {
          id: 'faq',
          path: '/seputar-pertanyaan',
          className: 'text-white transition hover:opacity-75',
          title: 'FAQ',
          show: true,
        },
        {
          id: 'hubungi-kami',
          path: '/hubungi-kami',
          className: 'text-white transition hover:opacity-75',
          title: 'HUBUNGI KAMI',
          show: !isMobile,
        },
        {
          id: 'syarat-dan-ketentuan',
          path: '/syarat-ketentuan-umum',
          className: 'text-white whitespace-nowrap transition hover:opacity-75',
          title: 'SYARAT & KETENTUAN',
          show: true,
        },
        {
          id: 'pemberitahuan-privasi',
          path: '/pemberitahuan-privasi',
          className: 'text-white transition hover:opacity-75',
          title: 'PEMBERITAHUAN PRIVASI',
          show: true,
        },
        {
          id: 'review-produk',
          path: '/review-produk',
          className: 'text-white transition hover:opacity-75',
          title: 'REVIEW PRODUK',
          show: !isMobile,
        },
        {
          id: 'hubungi-Kami',
          path: '/hubungi-kami',
          className: 'text-white transition hover:opacity-75',
          title: 'HUBUNGI KAMI',
          show: isMobile,
        },
        {
          id: 'dealer-toyota',
          path: '/dealer-toyota',
          className: 'text-white transition hover:opacity-75',
          title: 'DEALER TOYOTA',
          show: isMobile,
        },
      ],
    },
  ];
};
const socialMedia = (enableSharing) => {
  return [
    {
      link: 'https://www.facebook.com/Auto2000official',
      title: 'Facebook',
      icon: <FaFacebookF color="#BDBCBC" id="footer-facebook" size="24px" />,
      disabled: false,
    },
    {
      link: 'https://www.instagram.com/auto2000id/',
      title: 'Instagram',
      icon: <FaInstagram color="#BDBCBC" id="footer-instagram" size="24px" />,
      disabled: enableSharing,
    },
    {
      link: 'https://www.youtube.com/user/auto2000csr',
      title: 'Youtube',
      icon: <FaYoutube color="#BDBCBC" id="footer-youtube" size="24px" />,
      disabled: enableSharing,
    },
    {
      link: 'https://twitter.com/Auto2000ID',
      title: 'X',
      icon: <Xlogo fill="#BDBCBC" size="22" />,
      disabled: enableSharing,
    },
    {
      link: 'https://wa.me/+6282289802000',
      title: 'Whatsapp',
      icon: <FaWhatsapp color="#BDBCBC" id="footer-whatsapp" size="24px" />,
      disabled: enableSharing,
    },
    {
      link: 'https://www.tiktok.com/@auto2000official?is_from_webapp=1&sender_device=pc',
      title: 'Tiktok',
      icon: <FaTiktok color="#BDBCBC" id="footer-tiktok" size="24px" />,
      disabled: enableSharing,
    },
  ];
};
const downloadOn = [
  {
    id: 'astra-playstore',
    link: 'https://play.google.com/store/apps/details?id=id.co.astra.ai.dev1',
    icon: <LogoGooglePlay />,
  },
  {
    id: 'astra-apps-store',
    link: 'https://apps.apple.com/id/app/auto2000/id421805050',
    icon: <LogoAppStore />,
  },
];

export default { menu, socialMedia, downloadOn };
